import { REDUCE_BORDEREAU_SUMMARIES } from '../../constants/actions/policies';

export function reduceBordereauSummaries(payload) {
    return {
        type: REDUCE_BORDEREAU_SUMMARIES,
        payload,
    };
}
